import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { DemoLocalPDFToText2 } from './pages/DemoPdfText'
import { DevResumeAnalyzer } from './pages/DevResumeAnalyzer'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/test" Component={DemoLocalPDFToText2} />
        <Route index path="/" Component={DevResumeAnalyzer} />
      </Routes>
    </Router>
  )
}

export default App
